import React, { useState, useRef, useEffect } from "react";
import { Popup } from "react-vant";
import "react-vant/lib/index.css";
import styles from "./login.module.css";
import EmailLoginForm from "./EmailLoginForm";
import EmailRegistryForm from "./EmailRegistryForm";
import VerifyCodeForm from "./VerifyCodeForm";
import SetPasswordForm from "./SetPasswordForm";
import TopArea from "./ui/TopArea";
import FirstBanner from "./FirstBanner";
import EmailGoogleRegistredAndNoPassword from "./EmailGoogleRegistredAndNoPassword";
import UserTip from "./ui/UserTip";

interface LoginModalProps {
  show: boolean;
  onClose: () => void;
}
const LoginModal: React.FC<LoginModalProps> = ({ show, onClose }) => {
  const [currentStep, setCurrentStep] = useState(1); // 1: 显示google登录和邮箱登录  20 邮箱登录  21 邮箱注册 22 验证码 23 设置密码   24 邮箱已通过google注册但是没有设置密码
  const userInputEmail = useRef(""); // 用户当前输入的邮箱
  const verifyCodeType = useRef("1"); // 验证码的类型 0 注册 1 忘记密码
  const isFocus = useRef(true); // 当前表单是否foucus状态
  const EmailGoogleRegistredAndNoPasswordOrigin = useRef<"login" | "registry">(
    "login"
  );
  const handleEmailChange = (email: string) => {
    userInputEmail.current = email;
  };
  const handleVerifyCodeTypeChange = (type: string) => {
    verifyCodeType.current = type;
  };
  const goEmailLogin = () => {
    setCurrentStep(20);
  };
  const goRegistry = () => {
    setCurrentStep(21);
  };
  const goVerifyCode = () => {
    setCurrentStep(22);
  };
  const goLogin = () => {
    setCurrentStep(20);
  };
  const goSetPassword = () => {
    setCurrentStep(23);
  };
  const goEmailRegistred = () => {
    setCurrentStep(24);
  };
  const handleFocusChange = (focus: boolean) => {
    isFocus.current = focus;
  };
  const handleEmailGoogleRegistredAndNoPasswordOrigin = (
    origin: "login" | "registry"
  ) => {
    EmailGoogleRegistredAndNoPasswordOrigin.current = origin;
  };
  const clearData = () => {
    setCurrentStep(1);
    handleEmailChange("");
    handleVerifyCodeTypeChange("1");
  };
  const handleClose = () => {
    setTimeout(() => {
      clearData();
    }, 300);
    onClose();
  };

  // 渲染当前步骤的表单内容
  const renderStepContent = () => {
    switch (currentStep) {
      case 1:
        return (
          <div className="flex flex-col  justify-start items-center w-[100%] p-[16px] ">
            <FirstBanner goEmailLogin={goEmailLogin} onClose={handleClose} />
            <UserTip classNames="mt-[20px]" />
          </div>
        );

      case 20:
        return (
          <EmailLoginForm
            goRegistry={goRegistry}
            onClose={handleClose}
            goVerifyCode={goVerifyCode}
            onEmailChange={handleEmailChange}
            onVerifyCodeType={handleVerifyCodeTypeChange}
            onFocusChange={handleFocusChange}
            userInputEmail={userInputEmail.current}
            goEmailRegistred={goEmailRegistred}
            handleEmailGoogleRegistredAndNoPasswordOrigin={
              handleEmailGoogleRegistredAndNoPasswordOrigin
            }
            // autoFocus={isFocus.current}
          />
        );

      case 21:
        return (
          <EmailRegistryForm
            goVerifyCode={goVerifyCode}
            goLogin={goEmailLogin}
            userInputEmail={userInputEmail.current}
            onVerifyCodeType={handleVerifyCodeTypeChange}
            goEmailRegistred={goEmailRegistred}
            onEmailChange={handleEmailChange}
            onFocusChange={handleFocusChange}
            handleEmailGoogleRegistredAndNoPasswordOrigin={
              handleEmailGoogleRegistredAndNoPasswordOrigin
            }
          />
        );

      case 22:
        return (
          <VerifyCodeForm
            onClose={handleClose}
            goLogin={goEmailLogin}
            goSetPassword={goSetPassword}
            userInputEmail={userInputEmail.current}
            verifyCodeType={verifyCodeType.current}
          />
        );

      case 23:
        return (
          <SetPasswordForm
            onClose={handleClose}
            goLogin={goLogin}
            userInputEmail={userInputEmail.current}
            verifyCodeType={verifyCodeType.current}
            handleEmailChange={handleEmailChange}
          />
        );
      case 24:
        return (
          <EmailGoogleRegistredAndNoPassword
            onClose={handleClose}
            goLogin={goLogin}
            userInputEmail={userInputEmail.current}
            goVerifyCode={goVerifyCode}
            onVerifyCodeType={handleVerifyCodeTypeChange}
            origin={"login"}
          />
        );

      default:
        return null;
    }
  };

  return (
    <>
      <Popup
        visible={show}
        onClose={handleClose}
        closeable={false}
        safeAreaInsetBottom={true}
        position="bottom"
        round
        className={styles.customLoginPopup}
        closeOnClickOverlay={false}
        destroyOnClose={true}
        style={{
          width: "100%",
          maxHeight: "calc(100vh - 48px)",
        }}
      >
        <TopArea
          currentStep={currentStep}
          goEmailLogin={goEmailLogin}
          onClose={handleClose}
          goRegistry={goRegistry}
          goSetPassword={goSetPassword}
          goLogin={goLogin}
          goVerifyCode={goVerifyCode}
          verifyCodeType={verifyCodeType.current}
        ></TopArea>
        <div className="login-modal">
          <div className={styles.modalContent}>{renderStepContent()}</div>
        </div>
      </Popup>
    </>
  );
};

export default LoginModal;
